<template>
  <div class="products-panel">
    <div class="search-bar mt-2 mb-2">
      <button class="view-cart-btn text-white" @click="viewOpenTable">
        <font-awesome-icon icon="fa-solid fa-table" />
      </button>

      <input type="text" name="searchProducts" id="searchProducts" class="form-control-sm search-field"
        placeholder="Search by plu, barcode or name" @keyup.enter="searchProducts" @keyup="searchProducts"
        v-model="input">

      <button type="button" data-bs-toggle="offcanvas" data-bs-target="#shoppingCartCanvas"
        aria-controls="offcanvasRight" class="clear-btn view-cart-btn d-lg-none d-xl-none position-relative"
        @click="viewShoppingCart">
        <font-awesome-icon icon="fa-solid fa-cart-shopping" />
        <span class="badge badge-danger cart-count">{{ itemsInCart }}</span>
      </button>
    </div>

    <div ref="productsGrid" v-on:scroll="handleScroll" class="stock-list">
      <ProductItem v-for="item in stockProducts" :key="`product-` + item.PLU" :product="item"
        @click="addToSale(item)" />
    </div>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="shoppingCartCanvas" aria-labelledby="Shopping cart items">
      <button type="button" class="btn btn-close" data-bs-dismiss="offcanvas" aria-label="Close"
        id="canvasClose"></button>
      <div class="offcanvas-body">
        <ShoppingCart />
      </div>
    </div>
  </div>
</template>
<script>
import SubCategoryRow from "@/components/point-of-sale/sales/pos/SubCategoryRow.vue";
import StockSearchBar from "@/components/point-of-sale/stock-search/StockSearchBar.vue";
import ProductItem from "@/components/point-of-sale/sales/pos/ProductItem.vue";
import ShoppingCart from "@/components/point-of-sale/sales/pos/ShoppingCart.vue";

export default {
  name: 'MobileSearchedProducts',
  components: { ShoppingCart, ProductItem, StockSearchBar, SubCategoryRow },
  props:{
    showMainCategories:{
      type: Function,
      required: true
    }
  },
  computed: {
    itemsInCart() {
      return this.$store.getters.getSaleLines.length
    },
    stockProducts() {
      return this.$store.getters.getStockProducts(this.limit)
        .filter(item => item.archived === false)
        .sort((a, b) => a.Description.localeCompare(b.Description));
    },
    limit() {
      return this.$store.getters.getLimit;
    },
    categorySearch() {
      return this.$store.getters.getSearchCategories
    },
    currentSale() {
      return this.$store.getters.getCurrentSale
    }
  },
  data() {
    return {
      input: '',
      timer: undefined,
      isScrollable: false,
      scrollPosition: 0,
      maxScrollTop: 0,
    }
  },
  methods: {
    showCategories(){
      this.showMainCategories(true)
    },
    searchProducts() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.$utils.hideLoading()
      }
      this.timer = setTimeout(() => {
        this.$utils.showLoading()
        let cat = this.categorySearch

        const query = {
          description: this.input,
          category: cat.category || '',
          subCategory: cat.subCategory || '',
          sub2Category: cat.sub2Category || ''
        }
        return this.$store.dispatch('searchDescription', query)
          .finally(() => this.$utils.hideLoading())
      }, 300)
    },
    viewOpenTable() {
      return this.$router.push({ name: 'tables' })
    },
    viewShoppingCart() {
    },
    addToSale(item) {
      return this.$store.dispatch('getStockSetting', item.PLU)
        .then(async (set) => {
          let cost = Number(item.InclCost.toFixed(2));
          let price = Number(item.SellingIncl.toFixed(2));
          let description = item.Description;


          let quantity = 1;
          if (set.getQtyFromPrice) {
            const { value: totalItemPrice } = await Swal.fire({
              title: 'Enter Total Item Price',
              input: 'number',
              icon : "question",
              inputLabel: 'Total Item Price',
              inputPlaceholder: 'Enter the total price for the items',
              showCancelButton: true,
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              inputValidator: (value) => {
                if (!value || isNaN(value) || value <= 0) {
                  return 'Please enter a valid price!';
                }
              }
            });

            if (totalItemPrice) {
              quantity = totalItemPrice / price;
            }
          }

          if (cost > price) {
            const result = await Swal.fire({
              allowOutsideClick: false,
              icon: "warning",
              showCancelButton: true,
              showLoaderOnConfirm: true,
              title: `Cost price is greater than Selling price`,
              confirmButtonText: 'Proceed',
              focusConfirm: false,
            });

            if (!result.isConfirmed) {
              return;
            }
          }

          if (set.askForDescription || set.askForBoth) {
            description = (await this.askForDescription(item));
          }

          if (set.askForPrice || set.askForBoth) {
            price = (await this.askForPrice(item));
          }

          let tourismLevy = 0.0;
          if (set.tourism){
            let obj = { amount : price, incl : true }
            tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
          }

          if (set.cookingLink) {
            return this.$router.push({
              name: 'instruction',
              query: { plu: item.PLU, saleNumber: this.$route.query.saleNumber }
            });
          }
          let specialPrice = this.$store.getters.getItemSpecialPrice(item.PLU)
          if (specialPrice) {
            responses.showSuccess(`Special Detected`)
            price = specialPrice;
          }
          let obj = {
            Plu: item.PLU,
            Description: description,
            Qty: quantity,
            Unit: price,
            Line: price,
            Discount: 0,
            tourismLevy,
            vat: 0,
            instructions: []
          }
          this.$store.commit('addToCurrentSaleLines', obj)

          return this.$store.dispatch(`calculateTipAmount`)
        })
    },
    askForPrice(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${$utils.formatMoney(item.SellingIncl)}</h6>
               <input type="number" step="0.01" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return parseFloat(item.SellingIncl.toFixed(2))
      })
    },
    askForDescription(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Description`,
        html: `<h6 >Description : ${item.Description}</h6>
               <textarea id="desc-ask" class="swal2-input" placeholder="Description" style="max-width: 70%">`,
        confirmButtonText: 'Set Description',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#desc-ask').value
          if (!value || value.toString().trim() === "") {
            Swal.showValidationMessage(`Please enter a valid Description`)
          }
          return value;
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return item.Description
      })
    },
    scrollToTop() {
      const newScrollTop = Math.max(this.scrollPosition - 250, 0);
      this.$refs.productsGrid.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    async scrollToBottom() {
      await this.$store.commit(`setLimit`, this.limit + 4);
      const newScrollTop = Math.min(this.scrollPosition + 250, this.maxScrollTop);
      this.$refs.productsGrid.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      const scroll = {
        scrollTop: this.$refs.productsGrid.scrollTop,
        scrollHeight: this.$refs.productsGrid.scrollHeight,
        clientHeight: this.$refs.productsGrid.clientHeight
      }
      this.scrollPosition = scroll.scrollTop
      this.maxScrollTop = scroll.scrollHeight - scroll.clientHeight
      this.isScrollable = scroll.scrollHeight > scroll.clientHeight;
    },
  }
}
</script>

<style lang="scss" scoped>
@media (min-height: 769px) {
  .stock-list {
    height: 83vh !important;
  }
}

.stock-list {
  height: 77vh;
  padding-bottom: 77px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.offcanvas {
  padding: 0;

  .offcanvas-body {
    padding: 0 !important;
    position: relative;
  }
}

.products-panel {
  padding: 2px 5px 0 5px;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #eee;
  position: relative;
  .current-category-bar{
    width: 100%;
      padding-bottom: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 14px;
    .clear-btn{
      margin:0;
      height: 40px;
      width:40px;
      color: #252525;
      background: transparent;
      border:none
    }
    .title{
      margin: 0;
      white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;


        @supports (-webkit-line-clamp: 2) {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: initial;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
    }
  }
  .scroll-controls {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .scroll-control {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: #0092f7;
      color: white;
    }
  }

  .search-bar {
    display: flex;
    flex-direction: row;
    gap: 8px;

    .search-field {
      width: 100%;
    }

    .view-cart-btn {
      background: #0092f7;
      color: white;
      border-radius: 5px;

      .cart-count {
        position: absolute;
        top: -10px;
        right: -10px;
        color: white;
        background: coral;
      }
    }
  }

  .product-grid {
    overflow-y: auto;
    overflow-x: hidden;
    display: grid;
    gap: 1em;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-auto-rows: 1fr;  /* Automatically adjust row height based on content */
  }

}
</style>